export default __webpack_public_path__ + "static/media/BEL-BNB.5c1ea8a5.svg";